var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _path3, _rect8, _path4, _rect9, _path5, _rect10, _rect11, _rect12, _rect13, _path6, _mask, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 16.4023H47.8672C50.9048 16.4023 53.3672 18.8648 53.3672 21.9023V59.4023H27.8672C24.8296 59.4023 22.3672 56.9399 22.3672 53.9023V16.4023Z",
    stroke: "#FC0D1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 21.9023,
    width: 22,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8672,
    y: 45.9023,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 48.9023,
    width: 22,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 27.9023,
    width: 16,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8672,
    y: 39.9023,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8672 43.9023C36.8672 43.3501 37.3149 42.9023 37.8672 42.9023H48.3672C48.6433 42.9023 48.8672 43.1262 48.8672 43.4023C48.8672 43.6785 48.6433 43.9023 48.3672 43.9023H36.8672Z",
    fill: "#FC0D1B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8672,
    y: 36.9023,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 51.9023,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8672 46.4023C26.8672 46.1262 27.091 45.9023 27.3672 45.9023H29.8672C30.4195 45.9023 30.8672 46.3501 30.8672 46.9023H27.3672C27.091 46.9023 26.8672 46.6785 26.8672 46.4023Z",
    fill: "#FC0D1B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8672,
    y: 24.9023,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8672 40.4023C26.8672 40.1262 27.091 39.9023 27.3672 39.9023H29.8672C29.8672 40.4546 29.4195 40.9023 28.8672 40.9023H27.3672C27.091 40.9023 26.8672 40.6785 26.8672 40.4023Z",
    fill: "#FC0D1B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8672,
    y: 27.9023,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8672 31.4023C26.8672 31.1262 27.091 30.9023 27.3672 30.9023H39.8672C39.8672 31.4546 39.4195 31.9023 38.8672 31.9023H27.3672C27.091 31.9023 26.8672 31.6785 26.8672 31.4023Z",
    fill: "#FC0D1B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 24.9023,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 33.9023,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8672,
    y: 36.9023,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8672,
    y: 24.9023,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "#FC0D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.753 41.1384C32.0077 40.0143 33.1707 40.0501 34.2419 41.2457C35.3131 42.4414 35.2213 43.6013 33.9666 44.7255L32.4129 46.1174L29.1993 42.5304L30.753 41.1384ZM32.7944 44.2249L33.175 43.8839C33.6581 43.451 33.6677 42.9757 33.2038 42.4578L32.9235 42.145C32.4595 41.6271 31.986 41.5845 31.5028 42.0174L31.1222 42.3583L32.7944 44.2249ZM33.2572 38.8949L36.3594 36.1157L37.1301 36.976L35.1802 38.7229L35.6239 39.2182L37.2923 37.7235L38.0303 38.5473L36.3619 40.042L36.8523 40.5894L38.8388 38.8098L39.6095 39.67L36.4708 42.4819L33.2572 38.8949ZM39.4077 33.3847C39.5885 33.2228 39.7878 33.1131 40.0058 33.0557C40.2241 32.9917 40.4375 32.9885 40.6458 33.0462C40.8576 33.1008 41.0382 33.2115 41.1877 33.3784C41.5832 33.8198 41.6324 34.2769 41.3355 34.7497L41.3542 34.7706C41.9029 34.4669 42.3984 34.5619 42.8406 35.0554C43.0087 35.2431 43.1113 35.452 43.1482 35.6821C43.1855 35.9055 43.16 36.1289 43.0717 36.3521C42.9835 36.5752 42.8438 36.7725 42.6526 36.9437L40.2334 39.111L37.0199 35.524L39.4077 33.3847ZM39.4239 35.889L40.2164 35.179C40.2928 35.1105 40.332 35.0284 40.334 34.9327C40.3363 34.8303 40.3017 34.7392 40.23 34.6593L40.1833 34.6071C40.1148 34.5307 40.0311 34.4897 39.9323 34.4843C39.8303 34.4754 39.7429 34.5036 39.6699 34.569L38.8774 35.279L39.4239 35.889ZM40.6383 37.2446L41.5142 36.4599C41.5907 36.3914 41.6299 36.3092 41.6318 36.2135C41.6342 36.1112 41.5995 36.02 41.5279 35.9401L41.4812 35.888C41.4096 35.808 41.3243 35.7653 41.2255 35.7599C41.127 35.7479 41.0395 35.7761 40.9631 35.8446L40.0872 36.6294L40.6383 37.2446ZM43.9645 30.9565L46.356 33.6259L45.2038 34.6582L42.8123 31.9888L41.634 33.0444L40.8119 32.1268L44.3155 28.9879L45.1376 29.9055L43.9645 30.9565Z",
    fill: "#FC0D1B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-1_1623_1612",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.8672,
    y: 42.584,
    width: 25,
    height: 9,
    rx: 1,
    transform: "rotate(-41.8568 25.8672 42.584)"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8672,
    y: 42.584,
    width: 25,
    height: 9,
    rx: 1,
    transform: "rotate(-41.8568 25.8672 42.584)",
    stroke: "#FC0D1B",
    strokeWidth: 2.4,
    mask: "url(#path-20-inside-1_1623_1612)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebt);
export default __webpack_public_path__ + "static/media/Debt.840328fb7692937419bf0a424d586e8b.svg";
export { ForwardRef as ReactComponent };